<script setup="">
</script>

<template>

  <h1 class="text-3xl"><span class="line-through">Timmy Trumpet</span> Dimmy Drumbet</h1>
  <p>Mach es wie David, spiel Schlagzeug. Das macht Spaß!</p>
  <p>Wenn Du eine Tastatur hast, dann verwende die Tasten a bis k</p>

  <p class="mt-4" v-if="!ready">Einen Moment noch, bitte…</p>

  <div class="">

    <div class="my-4" v-if="ready">
      <button class="my-4 mx-4 p-4 border-2 rounded-xl font-bold w-32" @click="play(base)">Base</button>
      <button class="my-4 mx-4 p-4 border-2 rounded-xl font-bold w-32" @click="play(snare)">Snare</button>
      <button class="my-4 mx-4 p-4 border-2 rounded-xl font-bold w-32" @click="play(hit)">Hit</button>
      <button class="my-4 mx-4 p-4 border-2 rounded-xl font-bold w-32" @click="play(smtom)">kl. Tom</button>
      <button class="my-4 mx-4 p-4 border-2 rounded-xl font-bold w-32" @click="play(midtom)">m. Tom</button>
      <button class="my-4 mx-4 p-4 border-2 rounded-xl font-bold w-32" @click="play(bigtom)">gr. Tom</button>
      <button class="my-4 mx-4 p-4 border-2 rounded-xl font-bold w-32" @click="play(ride)">Ride</button>
      <button class="my-4 mx-4 p-4 border-2 rounded-xl font-bold w-32" @click="play(crash)">Crash</button>
    </div>

    <div v-for="voice in voices" :key="voice">
    <video  id="player" :controls="false" :ref="'player_'+voice" class="absolute" :class="visibleVoice===voice?'block':'hidden'" @loadedmetadata="loaded[voice-1] = true">
      <source type="video/mp4" src="./assets/TimmyDrumpet.mp4">
    </video>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    for(let i=0; i<this.voices;i++) {
      this.loaded[i] = false
    }

    window.addEventListener('keydown', (e) => {
      if(!this.ready) return
      switch (e.key) {
        case 'a': return this.play(this.base)
        case 's': return this.play(this.snare)
        case 'd': return this.play(this.hit)
        case 'j': return this.play(this.ride)
        case 'k': return this.play(this.crash)
        case 'f': return this.play(this.smtom)
        case 'g': return this.play(this.midtom)
        case 'h': return this.play(this.bigtom)
      }
    });
  },

  mounted() {
  },

  watch: {
    loaded: {
      handler(newValue, oldValue) {
        let tmp=true;
        this.loaded.forEach((e)=>{
          if(!e) tmp=false
        })
        this.ready = tmp;
      },
      deep: true
    }
  },

  data() {
    return {
      loaded: [],
      ready: false,
      voices: 16,
      visibleVoice: undefined,
      timeout: [],

      hit: [1,8],
      midtom: [2, 10, 14],
      smtom: [3, 7],
      bigtom: [11, 15],
      base: [12],
      ride: [4],
      crash: [5],
      snare: [6,9,13],
    }
  },


  methods: {

    play(type, duration=1000) {

      if(!this.ready) return
      //find spot in Video:
      let r = Math.floor(Math.random() * type.length)
      if (r >= type.length) r--;
      let sec = type[r]

      //find next free player
      for (let i = this.voices; i >= 1; i--) {
        if (this.$refs['player_' + i][0].paused) {
          return this.playOnInstance(i, sec, duration)
        }
      }
    },

    playOnInstance(i, sec, duration) {
      if(!this.ready) return
      if(this.timeout[i]) clearTimeout(this.timeout[i])
      this.$refs['player_'+i][0].pause()
      this.$refs['player_'+i][0].currentTime = sec
      this.$refs['player_'+i][0].play()
      this.visibleVoice = i;
      this.timeout[i] = setTimeout(function () {
        if(this.visibleVoice === i) this.visibleVoice = undefined
        this.$refs['player_'+i][0].pause()
        this.$refs['player_'+i][0].current = 0
      }.bind(this), duration)

    },
  }
}
</script>
